export const BULK_SPLITER = /\n|,|;/;
